// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
export type FingerprintQueryDetailsFragment = {
  __typename?: "QueryFingerprintStats";
  id: string;
  fingerprint: string;
  normalizedQuery: string;
  truncatedQuery: string;
  avgTime: number;
  callsPerMinute: number;
};

export const FingerprintQueryDetailsFragmentDoc = gql`
  fragment FingerprintQueryDetails on QueryFingerprintStats {
    id
    fingerprint
    normalizedQuery
    truncatedQuery
    avgTime
    callsPerMinute
  }
`;
